const Bundles = {
    async onLoad() {
        this._init();
        this.slots = [];
    },

    async fetchVariantData(productVariantPlatformId) {
        const response = await fetch('https://api.skio.com/storefront-http/get-classic-box-v2', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "productVariantPlatformId": productVariantPlatformId
            }),
        });
        return response.json();
    },

    _productItem(product, variantId) {
        const $template = $('.product-card--bundle').first().clone();
        const root = document.documentElement;
        const colorValue = getComputedStyle(root).getPropertyValue(`--${product.productSlug}`).trim();

        $template.find('.product-card__img img').attr('src', product.imageSrc).attr('alt', product.productTitle);
        $template.find('.product-card__name').attr('href', `/products/${product.productSlug}`).text(product.productTitle);
        $template.find('.quantity-picker__inp').val(product.quantity);
        $template.find('.product-card__img').css('background-color', colorValue);
        $template.attr('data-variant-id', variantId);

        return $template;
    },

    _renderSlots() {
        const totalList = $(this.container).find('.bundles__total');
        totalList.html('');

        if (this.slots.length) {
            this.slots.forEach((box) => {
                const $template = $('.bundles__total-item').first().clone();
                const root = document.documentElement;
                const colorValue = getComputedStyle(root).getPropertyValue(`--${box.productSlug}`).trim();

                $template.find('>.bundles__total-item-inner').css('background-color', colorValue);
                $template.attr('data-platform-id', box.platformId);
                $template.attr('data-product-title', box.productTitle);
                $template.find('img').attr('src', box.imageSrc);
                $template.find('.bundles__total-item-title').text(box.productTitle);
                // $template.find('.bundles__total-item-variant').text(currentSize);
                // $template.find('.bundles__total-item-qty').text(currentQTY);
                totalList.prepend($template);
            })
        }
    },

    _renderProducts(products) {
        products.forEach((productItem) => {
            const skioData = JSON.stringify(productItem);
            const productEl = this._productItem(productItem);
            productEl.attr('data-skio', skioData);
            this.productsGrid.append(productEl);
        })
    },

    _switchSize(variant) {
        this.maxBoxAmount = +variant.data('size');

        document.dispatchEvent(new CustomEvent("variantChanged", {
            detail: {
                variantId: variant.val()
            }
        }));
    },

    _isSlotAvailable() {
        return (this.slots.length + 1) <= this.maxBoxAmount;
    },

    _UIState() {
        this.productsGrid.find('.quantity-picker__inp').each((index, el) => {
            if (this.slots.length === this.maxBoxAmount) {
                $(".js-add-to-cart").attr('disabled', false);
                $(".bundles__sidebar").addClass('state-active');

                if ($(el).val() < 1) {
                    $(el).parent().addClass('state-disabled');
                }
            } else {
                $(".bundles__sidebar").removeClass('state-active');
                $(".js-add-to-cart").attr('disabled', true);
                if ($(el).val() < 1) {
                    $(el).parent().removeClass('state-disabled');
                }
            }
        })
    },

    _resetAll() {
        $('.quantity-picker__inp').each(function () {
            $(this).val(0);
        })
        this.slots = [];
        this._renderSlots();
    },

    _slotsChecker() {
        if (this.slots.length > this.maxBoxAmount) {
            this._resetAll();
        }
    },

    _updateSlots() {
        const productsList = $(this.container).find('.bundles__products');
        this.slots = [];

        productsList.find('.product-card--bundle').each((index, el) => {
            const currentItem = $(el);
            const productObject = currentItem.data('skio');
            const currentQty = +currentItem.find('.quantity-picker__inp').val();

            if (currentQty > 0) {
                for (let i = 0; i < currentQty; i++) {
                    if (this.slots.length < this.maxBoxAmount) {
                        this.slots.push(productObject);
                    }
                }
            }
        })
    },

    _updateQty() {
        this.totals.attr('data-current', this.slots.length);
        this.totals.attr('data-total', this.maxBoxAmount);
    },

    _prepareItems(items) {
        const itemMap = {};
        items.forEach(item => {
            const key = item.platformId; // Используем platformId как уникальный идентификатор объекта

            if (itemMap[key]) {
                itemMap[key].quantity += 1;
            } else {
                itemMap[key] = { ...item, quantity: 1 };
            }
        });

        return Object.values(itemMap)
    },

    _updateCartProperties() {

    },

    async _init() {
        const sizes = [];
        const variantsSwitchers = $(this.container).find('input[name="size"]');
        const activeVariant = $(this.container).find('input[name="size"]:checked');
        this.productsGrid = $(this.container).find('.bundles__products');
        this.maxBoxAmount;
        this.activeVariantId = activeVariant.val();
        this.totals = $('#item-qty');

        $(this.container).find('input[name="size"]').each((index, el) => {
            sizes.push($(el).val())
        })

        $('.hero .btn[href="#bundles"]').on('click', function () {
            $('html, body').animate({
                scrollTop: $('#bundles').offset().top - $("#shopify-section-header").height()
            }, 1000);
        });

        if (sizes.length) {
            const products = await this.fetchVariantData(sizes[0]);
            this._renderProducts(products.ClassicBoxV2.selectableProductVariants);
            this._switchSize(activeVariant);
            this._updateQty();
        }

        variantsSwitchers.on('change', (e) => {
            const activeVariant = $(e.currentTarget);
            this._switchSize(activeVariant)
            this._slotsChecker();
            this._UIState();
            this._updateQty();
            this.activeVariantId = activeVariant.val();
        })

        $(document).on('click', '.quantity-picker:not(.state-disabled) .quantity-picker__btn', (e) => {
            const $input = $(e.currentTarget).siblings('.quantity-picker__inp');
            let value = parseInt($input.val());

            if ($(e.currentTarget).hasClass('quantity-picker__btn--minus')) {
                if (value > 0) value--;
            } else {
                if (this._isSlotAvailable()) {
                    value++;
                }
            }

            $input.val(value);
            this._updateSlots();
            this._renderSlots();
            this._UIState();
            this._updateQty();
        });

        $('.js-add-to-cart').on('click', (e)=> {
            console.log();

            // const quantity = parseInt(document.querySelector('.quantity-picker__inp').value);
            const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
            const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

            const items = [
                {
                    id: this.activeVariantId,
                    quantity: 1,
                    ...(sellingPlanId && { selling_plan: sellingPlanId }),
                    properties: {
                        _isClassicBoxV2: true
                    }
                }
            ];

            const preparedItems = this._prepareItems(this.slots);

            if (!preparedItems.length) return;
            items.forEach(item => {
                console.log(preparedItems);
                preparedItems.forEach(box => {
                    item.properties[`${box.productTitle}`] = box.quantity;
                    item.properties[`_pv${box.platformId}`] = box.quantity;
                })
            })

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items })
            })
                .then(response => response.json())
                .then(response => {
                    // console.log(`SKIO added item to cart: ${response.items[0].product_title} x ${quantity}`);
                })
                .catch(error => {
                    console.error("SKIO error adding item to cart: ", error);
                });
        });

        $(".bundles__sidebar-header").on('click', function () {
            $(this).closest('.bundles__sidebar').toggleClass('state-active');
        })

        window.upcartOnCartUpdated = (cart) => {
            for (const item of cart.items) {
                const targetId = item.key.replace(':', '\\:')
                const relItem = $(".upcart-products-section").find(`#${targetId}`);

                if(relItem) {
                    relItem.find(".upcart-item-properties-anchor-after").html('');
                    for (let key in item.properties) {

                        if (!key.startsWith('_')) {
                            relItem.find(".upcart-item-properties-anchor-after").append(`<div class="upcart-item-property">${key}: ${item.properties[key]}</div>`)
                        }
                    }
                }
            }
            return cart;
        };



    },
};

export default Bundles;